// @flow
import uniqid from 'app/libs/uniqid.js'
import PubSub from 'pubsub-js'

export const openModalEventName: string = uniqid()

export const openModal = (modal: React$Node) => {
  PubSub.publish(openModalEventName, modal)
}
